import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import EditorSegments from "./EditorSegments.js";
import Context from "./Context.js";
import Icon from '@material-ui/core/Icon';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import Tooltip from '@material-ui/core/Tooltip';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
						
class EditorSearch extends Component {
	constructor(props) {
		super(props);
		this.onChangeSearch = this.onChangeSearch.bind(this);
		this.onChangereplace = this.onChangereplace.bind(this);
		this.next = this.next.bind(this);
		this.prev = this.prev.bind(this);
		this.search = this.search.bind(this);
		this.replace = this.replace.bind(this);
		
		// Estat
		this.state={
			searchValue: "",
			replaceValue: "",
			index: 0,
			found:-1
		}
		
	}
	onChangeSearch(e){
		this.setState({index: 0, found: -1, searchValue: e.target.value});
	}
	onChangereplace(e){
		this.setState({replaceValue: e.target.value});
		//this.setState({index: 0, found: -1, search: e.target.value});
	}
	
	next(e){
		if(this.props.foundSegments.length>0){
			let value = this.state.index+1 < this.props.foundSegments.length  ? this.state.index+1 : this.state.index;
			this.setState({index: value});
			this.props.gotoSegment(this.props.foundSegments[value]);
		}
		//this.setState({index: 0, found: -1, search: e.target.value});
	}
	prev(e){
		if(this.props.foundSegments.length>0){
			let value = this.state.index>0  ? this.state.index-1 : 0;
			this.setState({index: value});
			this.props.gotoSegment(this.props.foundSegments[value]);
		}
		//this.setState({index: 0, found: -1, search: e.target.value});
	}
	
	search(e){
		if(this.state.searchValue.length>0){
			this.props.search(this.state.searchValue);
		}else{
			this.setState({index: 0, found: -1, searchValue: ""});
			this.props.search("");
		}
	}
	replace(e){
		if(this.state.searchValue.length>0 && this.state.replaceValue.length>0){
			this.props.replace(this.state.searchValue, this.state.replaceValue);
		}
	}
	

	render() {
//		console.log("props Search: ");
//		console.log(this.props);
		var navegacio = "";
		let currentIndex = this.props.foundSegments.length>0 ? this.state.index+1 : 0;
		if(true){
			navegacio = <span>
							<span>{currentIndex}/{this.props.foundSegments.length}</span>
							<Tooltip title="Siguiente"><span style={{cursor: "pointer"}} onClick={this.next}><IconButton color="inherit" aria-label="Siguiente"><KeyboardArrowDownIcon /></IconButton></span></Tooltip>
							<Tooltip title="Anterior"><span style={{cursor: "pointer"}} onClick={this.prev}><IconButton color="inherit" aria-label="Anterior"><KeyboardArrowUpIcon /></IconButton></span></Tooltip>
						</span>
		}
		return(
			<span>
				Search:
				<input type="text" size="25" value={this.state.searchValue} onChange={this.onChangeSearch} />
				<Tooltip title="Search"><span style={{cursor: "pointer"}} onClick={this.search}><IconButton color="inherit" aria-label="search"><SearchIcon /></IconButton></span></Tooltip>
				{navegacio}
				<input type="text" size="25" value={this.state.replaceValue} onChange={this.onChangereplace} />
				<span style={{cursor: "pointer"}} onClick={this.replace}> [ replace ] </span>
			</span>);
	}
}

export default EditorSearch;